import Backbone from "backbone";
import Marionette from "backbone.marionette";

import $ from "jquery";
import _ from "lodash";

import template from "../templates/components/preferences.jst";
import modalTemplate from "../templates/components/modal.jst";

import modelUtil from "../models/util";
import config from "../config";
import AvailabilityComponent from "./availability";
import CommuteAddress from "./commuteAddress";

function shiftValue(value) {
    if (value) {
        if (Array.isArray(value)) {
            return value.reduce((x, y) => x | Number(y), 0);
        }
        return Number(value);
    }

    return 0;
}

const DEFAULT_PREFERENCES = {
    role: 0,
    shift: 0,
    search_status: 1,
    wage: config.WAGE_MIN,
    weekend: true,
    commute_type: modelUtil.COMMUTE_TYPE.DRIVING | modelUtil.COMMUTE_TYPE.TRANSIT,
    commute_length: 30,
};

const EditPreferencesView = Marionette.View.extend({
    getTemplate() {
        return this.options.template || template;
    },
    ui: {
        address: ".js-commute-address",
        addressInput: ".js-commute-address-input",
        autoApply: "#auto-apply",
        availTable: ".availability-table",
        form: ".preferences-form",
        wage: "[name=wage]",
    },
    events: {
        "click .btn-large": "onSubmit",
        "click .js-save-and-view": "onSaveAndView",
        "input @ui.wage": "onWageChange",
    },
    initialize() {
        this.redirect = !!this.options.redirect;
        this.data = this.options.data || { review: false, address: null };

        const path = _.trimEnd(window.location.pathname, "/");
        this.onJobsPage = path === "/jobs";
        this.onProfilePage = path === "/profile";
    },
    serializeData() {
        const prefs = _.clone(this.data.preferences || DEFAULT_PREFERENCES);

        if (prefs.wage) {
            prefs.wage = Math.floor(Number(prefs.wage));
        } else {
            prefs.wage = config.WAGE_MIN;
        }

        return {
            review: this.data.review || false,
            address: this.data.address,
            prefs,
            statusMap: modelUtil.CANDIDATE_SEARCH_STATUS_MAP,
        };
    },
    onWageChange() {
        let val = Number(this.ui.wage.val());
        if (val) {
            val = Math.min(Math.max(0, Math.floor(val)), config.WAGE_MAX);
            this.ui.wage.val(val);
        } else {
            this.ui.wage.val("");
        }
    },
    onRender() {
        const prefs = this.data.preferences || {};
        this.availComponent = new AvailabilityComponent({
            el: this.ui.availTable,
            inModal: true,
            prefix: "prefs-",
            data: {
                pref_shift_day: prefs.shift_day,
                pref_shift_swing: prefs.shift_swing,
                pref_shift_night: prefs.shift_night,
                pref_shift_weekend: prefs.shift_weekend,
                pref_shift_overtime: prefs.shift_overtime,
            },
        });
        this.availComponent.render();

        this.address = new CommuteAddress({
            el: this.ui.address,
            addressEl: this.ui.addressInput,
            address: this.data.address,
            artificialWaitTime: 0,
        });
        // this.listenTo(this.address, 'finish', this.onUpdateAddress);
        this.address.render();
    },
    onSubmit(event) {
        event.preventDefault();

        this.submit();
    },
    onSaveAndView(event) {
        event.preventDefault();

        this.listenTo(this, "saved", () => {
            if (this.onJobsPage) {
                const data = this.getFormData();
                data.weekend = !!data.weekend;
                // lol gross what
                Backbone.Radio.channel("filters").trigger("preferences", data);
            } else {
                window.location = "/jobs/";
            }
        });

        if (!this.onJobsPage) {
            this.redirect = true;
        }

        this.submit();
    },

    submit() {
        if (!this.availComponent.validate()) {
            return;
        }

        const data = this.getFormData();

        if (this.redirect) {
            data.redirect = 1;
        }

        $.ajax({
            url: "/api/v1/preferences/",
            type: "PATCH",
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        }).done(() => {
            this.trigger("saved");

            if (this.onProfilePage) {
                Backbone.Radio.channel("profile").trigger("preferences", data);
            }

            if (window.location.hash === "#set-preferences") {
                window.location.reload();
            }

            // This is gross, but w/e. Updates search status in place on the page
            $(".js-candidate-status-text").each((idx, el) => {
                $(el).text(modelUtil.CANDIDATE_SEARCH_STATUS_MAP[data.search_status]);
            });
            Object.keys(modelUtil.CANDIDATE_SEARCH_STATUS).forEach((key) => {
                const id = modelUtil.CANDIDATE_SEARCH_STATUS[key];
                $(`.candidate-status${id}`)
                    .removeClass(`candidate-status${id}`)
                    .addClass(`candidate-status${data.search_status}`);
            });
        });
    },
    getFormData() {
        const data = this.ui.form.serializeHash();

        data.auto_apply_enabled = this.ui.autoApply[0].checked ? 1 : 0;
        data.search_status = Number(data.search_status);
        data.role = shiftValue(data.role);
        data.shift = shiftValue(data.shift);
        data.commute_type = shiftValue(data.commute_type);
        data.commute_length = Number(data.commute_length);
        data.wage = Math.floor(Number(data.wage));

        const availData = this.availComponent.getData();
        _.extend(data, availData);
        data.shift_day = availData.pref_shift_day;
        data.shift_swing = availData.pref_shift_swing;
        data.shift_night = availData.pref_shift_night;
        data.shift_overtime = availData.pref_shift_overtime;
        data.shift_weekend = availData.pref_shift_weekend;

        return data;
    },
});

const PreferencesModal = Marionette.View.extend({
    el: "#edit-preferences-modal",
    template: modalTemplate,
    ui: {
        content: ".modal-content",
    },
    showError(msg) {
        this.ui.form.addClass("has-error");
        this.ui.error.text(msg);
    },
    onRender() {
        const self = this;
        $.ajax({
            type: "GET",
            url: "/api/v1/preferences/",
            dataType: "json",
            contentType: "application/json",
        })
            .done((data) => {
                data.preferences = _.defaults(data.preferences, DEFAULT_PREFERENCES);

                self.view = new EditPreferencesView({
                    el: self.ui.content,
                    data,
                    showAddress: true,
                });
                self.view.render();
                self.listenTo(self.view, "saved finished", () => {
                    $.modal.close();
                });
            })
            .fail(() => {
                self.ui.content.text(
                    "We were unable to display your preferences. Please try again",
                );
            });

        this.$el.addClass("modal-full");
        this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
});

export default {
    DEFAULT_PREFERENCES,
    Modal: PreferencesModal,
    View: EditPreferencesView,
};
